import * as o from "react";
import s from "../lib/IconBase.es.js";
import a from "../defs/ArrowsOut.es.js";
const r = o.forwardRef((t, e) => /* @__PURE__ */ o.createElement(s, { ref: e, ...t, weights: a }));
r.displayName = "ArrowsOutIcon";
const n = r;
export {
  n as ArrowsOut,
  r as ArrowsOutIcon
};
